import { Injectable } from '@angular/core';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
}) 

export class MonitoringService {
  appInsights: ApplicationInsights;
  isenable= environment.appInsights.isenable;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { // option to call manually  
    if(!this.isenable) 
    return
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if(!this.isenable) 
    return
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if(!this.isenable) 
    return
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if(!this.isenable) 
    return
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any },severityLevel?:SeverityLevel) {
    if(!this.isenable) 
    return
    this.appInsights.trackTrace({ message: message}, properties);
  }

}
